import React from "react";
import { RearrangeSmallIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const DraggableColumn = ({ isDragging, isPreview, className, children }) => {
  return (
    <div
      className={classNames(
        "tw-rounded",
        { "tw-bg-theme-200": isDragging },
        { "hover:tw-bg-theme-200": !isDragging && !isPreview },
        { "tw-bg-page-paper-main tw-shadow-md": isPreview }
      )}
    >
      <div
        className={classNames("draggable-settings-column tw-relative", className, {
          "tw-opacity-0": isDragging && !isPreview,
        })}
      >
        <div
          className={classNames(
            "task-item-drag-handler tw-absolute tw-flex tw-items-center tw-left-0 tw-top-0 tw-h-full tw-w-7 tw-justify-center"
          )}
        >
          <RearrangeSmallIcon className="tw-fill-theme-900 drag-icon tw-mr-1" />
        </div>
        {children}
      </div>
    </div>
  );
};

DraggableColumn.propTypes = {
  isDragging: PropTypes.bool,
  isPreview: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.any,
};
